export default "__VITE_ASSET__de70a25d__"